var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgChatNewLine = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7616_56106)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.66925 2.0459V3.37923H3.00258V12.3026L4.17792 11.3792H13.6693V6.71257H15.0026V12.0459C15.0026 12.2227 14.9323 12.3923 14.8073 12.5173C14.6823 12.6423 14.5127 12.7126 14.3359 12.7126H4.63925L1.66925 15.0459V2.71257C1.66925 2.53575 1.73949 2.36618 1.86451 2.24116C1.98954 2.11614 2.15911 2.0459 2.33592 2.0459H9.66925ZM13.0026 2.0459V0.0458984H14.3359V2.0459H16.3359V3.37923H14.3359V5.37923H13.0026V3.37923H11.0026V2.0459H13.0026Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7616_56106"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    transform: "translate(0.335938 0.0458984)"
  })))));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgChatNewLine);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/chat-new-line.d8e52f022fa0971d2e7fafe74271ba9d.svg";